<template>
  <main class="contact">
    <Header/>
    <section class="template-header d-flex justify-center align-center text-center">
      <div class="shadow"></div>
      <div class="item">
        <h1 class="font-weight-regular text-uppercase px-4">{{ $vuetify.lang.t('$vuetify.contact.template-header.title') }}</h1>
      </div>
    </section>
    <section class="template pt-6 pb">
      <v-container>
        <v-row>
          <v-col class="text-center">
            <h1>{{ $vuetify.lang.t('$vuetify.contact.template.title') }}</h1>
          </v-col>
        </v-row>
        <v-row class="pt-6">
          <v-col>
            <p class="mb-0">{{ $vuetify.lang.t('$vuetify.contact.template.text') }}</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm=6 cols=12>
            <h3 class="mb-3">{{ $vuetify.lang.t('$vuetify.contact.template.address.title') }}</h3>
            <p>{{ $vuetify.lang.t('$vuetify.contact.template.address.russia') }}</p>
            <p class="mb-0">{{ $vuetify.lang.t('$vuetify.contact.template.address.france') }}</p>
          </v-col>
          <v-col sm=6 cols=12>
            <h3 class="mb-3">{{ $vuetify.lang.t('$vuetify.contact.template.tel.title') }}</h3>
            <a href="">{{ $vuetify.lang.t('$vuetify.contact.template.tel.phone1') }}</a> <br/>
            <a href="">{{ $vuetify.lang.t('$vuetify.contact.template.tel.phone2') }}</a> <br/>
            <a href="">{{ $vuetify.lang.t('$vuetify.contact.template.tel.phone3') }}</a>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <Footer/>
  </main>
</template>

<script>
  import Header from '../components/Header.vue'
  import Footer from '../components/Footer.vue'
  export default {
    components: {
      Header,
      Footer
    }
  }
</script>

<style lang="scss">
  #app {
    .contact {
      height: 100%;
      .template-header {
        background: url('../assets/background.jpg') center center /cover;
        .shadow {
          opacity: 1;
        }
      }
    }
  }
</style>